import { IApplicationState } from '../../types/redux';

export const getReviewById = (id: string) => (state: IApplicationState) => {
  return state.reviews.byId[id];
};

export const getAnswersByReviewId = (id: string) => (state: IApplicationState) => {
  const review = state.reviews.byId[id];

  return review.answers.map(id => state.answers[id]);
};
